export const AUTH_STORAGE_KEY = 'session_token';
export const LEGACY_AUTH_STORAGE_KEY = 'pi_session_token';

export function getSessionToken(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEY) ?? localStorage.getItem(LEGACY_AUTH_STORAGE_KEY);
}

export function setSessionToken(token: string): void {
  localStorage.setItem(AUTH_STORAGE_KEY, token);
}

export function removeSessionToken(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  localStorage.removeItem(LEGACY_AUTH_STORAGE_KEY);
}

export function isAuthenticated(): boolean {
  return Boolean(getSessionToken());
}

export function redirectToLogin(path: string = '/'): void {
  removeSessionToken();
  window.location.href = path;
}
